<svc-chip *ngIf="control"
  class="w-full"
  [svcTestId]="inputTestId"
  [formControl]="control"
  [options]="chipOptions"
  [label]="label ?? ('Usuários' | transloco)"
  [icon]="icon"
  [type]="type"
  [readonly]="readonly"
  [inputId]="inputId"
  [placeholder]="placeholder"
  [fallbackTextValue]="fallbackTextValue"
  [loading]="loading || isLoading"
  readonlyStyle="transparent-chip"
>
  <ng-template let-option="option">
    <div class="flex gap-1.5">
      <svc-user-avatar [info]="option.data" borderColor="transparent"></svc-user-avatar>
      <div class="flex-auto flex items-center">
        {{ option.label }}
      </div>
    </div>
  </ng-template>
</svc-chip>
